package com.iptvplayer.shared.db

import kotlin.String

public data class ChannelEntity(
  public val id: String,
  public val sourceId: String,
  public val name: String,
  public val streamUrl: String,
  public val logoUrl: String?,
  public val groupName: String?,
  public val streamType: String,
)
